// Helper per URL SEO (slug) con retrocompatibilità UUID e meta dinamici.

export const isUuid = (s) =>
  typeof s === 'string' &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(s);

export const productUrl = (p) => `/prodotto/${(p && (p.slug || p.id)) || ''}`;
export const crafterUrl = (c) => `/artigiano/${(c && (c.slug || c.id)) || ''}`;

// Imposta title, meta description e canonical in modo dinamico (client-side).
export const setPageSeo = ({ title, description, canonicalPath, image }) => {
  if (title) document.title = title;
  // Open Graph (letti da chi esegue JavaScript; per i bot dei social c'è /api/seo/render)
  const og = (prop, content) => {
    if (!content) return;
    let el = document.head.querySelector(`meta[property="${prop}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('property', prop);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };
  og('og:title', title);
  og('og:description', description != null ? String(description).slice(0, 200) : null);
  if (canonicalPath) og('og:url', `${window.location.origin}${canonicalPath}`);
  if (image) og('og:image', image);

  const ensure = (selector, create) => {
    let el = document.head.querySelector(selector);
    if (!el) {
      el = create();
      document.head.appendChild(el);
    }
    return el;
  };

  if (description != null) {
    const m = ensure('meta[name="description"]', () => {
      const e = document.createElement('meta');
      e.setAttribute('name', 'description');
      return e;
    });
    m.setAttribute('content', String(description).slice(0, 160));
  }

  if (canonicalPath) {
    const l = ensure('link[rel="canonical"]', () => {
      const e = document.createElement('link');
      e.setAttribute('rel', 'canonical');
      return e;
    });
    l.setAttribute('href', `${window.location.origin}${canonicalPath}`);
  }
};

// Dati strutturati (schema.org) della pagina: uno script per chiave, rimosso con data = null
export const setJsonLd = (key, data) => {
  const id = `ld-${key}`;
  const existing = document.getElementById(id);
  if (!data) {
    if (existing) existing.remove();
    return;
  }
  const el = existing || document.createElement('script');
  el.id = id;
  el.type = 'application/ld+json';
  el.textContent = JSON.stringify(data);
  if (!existing) document.head.appendChild(el);
};
